import { Person } from './person';

export class Signature {
	 id: string;
	 user_id: string;	 
	 document_id: string;
	 document_type: string;
	 read_document: boolean;	 
	 signature: string;
	 user_person_id: string;
	 role: string;
	 accepted_terms: boolean;
	 contact_consent: boolean;
	 created_date: Date;
	 ip_address: string;
	 federation: string;
	 federation_number: string;
	 party_to_entry: string;
	 responsible_party: boolean;
	 updated: boolean = false;
	 request_signature: boolean;
     signed_date: Date;
	 request_signature_email: string;


	 //Loaded by some DAO on REST API for convenience
	 person: Person;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}